module.exports = __webpack_public_path__ + "static/media/Arun_H.aa9d0523.jpg";